import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowTriangleTop"><Path d="M3.54004 20.0003H20.4671L12.0036 3.07324L3.54004 20.0003Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
